import { connect } from 'react-redux';
import {
  isFolderSectionsUserProgressComplete,
  getSectionsProgressInFolder,
  publishedSectionIdsByParent,
} from '@core/materials/selectors';
import {
  getUserPermissionsInCurrentSpace,
  hasPermission,
  MATERIAL_PERMISSIONS,
} from '@core/utils/permissions';

import {
  selectors as materialSelectors,
  operations,
} from '../../../../../store/materials';
import * as classRoomSelectors from '../../../../../../core/selectors/classroom';
import {
  canEditMaterials,
  canCreateMaterials,
  canViewMaterials,
  canAccessEducatorArea,
  isMaterialRbacEnabled,
} from '../../../../../../core/materials/permissions';
import FolderListItem from './FolderListItem';

const mapStateToProps = (state, ownProps) => {
  const folder = materialSelectors.getMaterial(state, ownProps.materialId);
  // In educator area: if user has educator area permission, they can do everything
  const canEdit = ownProps.educatorOnly
    ? canAccessEducatorArea(state)
    : canEditMaterials(state);
  const canCreate = ownProps.educatorOnly
    ? canAccessEducatorArea(state)
    : canCreateMaterials(state);
  const canView = ownProps.educatorOnly
    ? canAccessEducatorArea(state)
    : canViewMaterials(state);
  const isStudent = classRoomSelectors.getIsStudent(state);
  // When RBAC is disabled, fallback to student check (legacy behavior)
  // When RBAC is enabled, only return true if user has progress permission
  const hasProgressPermission = hasPermission(
    state,
    MATERIAL_PERMISSIONS.PROGRESS,
    isStudent
  );

  // For progress overview, only show published materials (not hidden, not educator-only)
  // For regular materials list, show all materials based on permissions
  const materialIds = ownProps.isOverview
    ? publishedSectionIdsByParent(state, ownProps.materialId)
    : materialSelectors.sectionIdsByParent(
        state,
        ownProps.materialId,
        folder.educatorOnly
      );

  return {
    isFolder: true,
    primaryText: folder ? folder.title : '',
    expanded: materialSelectors.isExpanded(state, ownProps.materialId),
    hidden: folder.hidden,
    parent: folder.parent,
    materialIds,
    isInstructor: classRoomSelectors.isInstructor(state),
    isStudent,
    allSectionsCompleted: isFolderSectionsUserProgressComplete(
      state,
      ownProps.materialId
    ),
    sectionsProgress: getSectionsProgressInFolder(state, ownProps.materialId),
    canEdit,
    canCreate,
    canView,
    permissions: getUserPermissionsInCurrentSpace(state),
    isRbacEnabled: isMaterialRbacEnabled(state),
    hasProgressPermission,
  };
};

const mapsDispatchToProps = (dispatch, ownProps) => ({
  toggleFolder: () => dispatch(operations.toggleFolder(ownProps.materialId)),
  onReorder: (params) => dispatch(operations.reorderMaterial(params)),
});

export default connect(mapStateToProps, mapsDispatchToProps)(FolderListItem);
